export const ApprovalLogInformationBadge = ({
    label = "",
    value = "",
}) => {
    return (
        <div>
            <p className="uppercase tracking-[0.12em]">
                {label}
            </p>
            <p className="mt-1 text-sm text-primary">
                {value ?? "N/A"}
            </p>
        </div>
    )
}